export const ENV = {
    BASE_URL: '/',
    API_MODE: 'api',
        API_URL: 'https://api.use-less.jp/api/admin',
    APP_API_URL: 'https://api.use-less.jp/api/',
    LOCALE : 'ja'
}
